import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = {
  key: 0,
  class: "fluid grid"
}
const _hoisted_5 = { class: "field col-12 md:col-3" }
const _hoisted_6 = { class: "field col-12 md:col-3" }
const _hoisted_7 = { class: "field col-12 md:col-4" }
const _hoisted_8 = { class: "field col-12 md:col-2" }
const _hoisted_9 = { class: "field col-12 md:col-12" }
const _hoisted_10 = { class: "field col-12 md:col-12" }
const _hoisted_11 = { class: "field col-12 md:col-6" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "field col-12 md:col-6" }
const _hoisted_14 = { class: "field col-12 md:col-4" }
const _hoisted_15 = { class: "field col-12 md:col-4" }
const _hoisted_16 = { class: "field col-12 md:col-2" }
const _hoisted_17 = { class: "field col-12 md:col-2" }
const _hoisted_18 = { class: "field col-12 md:col-12" }
const _hoisted_19 = { class: "field col-12 md:col-12" }
const _hoisted_20 = { class: "field col-12 md:col-12" }
const _hoisted_21 = { class: "field col-12 md:col-12" }
const _hoisted_22 = { class: "field col-12 md:col-12" }
const _hoisted_23 = { class: "field col-12 md:col-4" }
const _hoisted_24 = { class: "field col-12 md:col-4" }
const _hoisted_25 = { class: "field col-12 md:col-2" }
const _hoisted_26 = { class: "field col-12 md:col-2" }
const _hoisted_27 = { class: "field col-12 md:col-3 flex-wrap" }
const _hoisted_28 = { class: "field col-12 md:col-3" }
const _hoisted_29 = { class: "field col-12 md:col-3" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "compass-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-10" }, [
        _createElementVNode("h4", null, "Building Warrant of Fitness (BWOF)")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.showDetails,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDetails) = $event)),
          style: {"float":"right"},
          onChange: _ctx.onToggleDetails
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    (_ctx.visibleDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[27] || (_cache[27] = _createElementVNode("label", null, "BWOF issued by", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedBwofData.bwofIssuedBy,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.receivedBwofData.bwofIssuedBy) = $event)),
              options: _ctx.bwofIssuedOptions,
              optionValue: "value",
              optionLabel: "label",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[29] || (_cache[29] = _createElementVNode("label", null, "BWOF issued date", -1)),
            _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.receivedBwofData.bwofIssuedDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.receivedBwofData.bwofIssuedDate) = $event)),
              dateFormat: "d M yy",
              showIcon: true,
              showButtonBar: true,
              class: "w-100pc",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[31] || (_cache[31] = _createElementVNode("label", null, "Intended life of the building", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.intendedLifeOfTheBuilding,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receivedBwofData.intendedLifeOfTheBuilding) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[32] || (_cache[32] = _createElementVNode("label", null, "First constructed", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.firstConstructed,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receivedBwofData.firstConstructed) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[33] || (_cache[33] = _createElementVNode("label", null, "BWOF located", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.bwofLocated,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receivedBwofData.bwofLocated) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Building safety manual located", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.buildingSafetyManualLocated,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.receivedBwofData.buildingSafetyManualLocated) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Building safety manual issued or updated", -1)),
            _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Calendar, {
                modelValue: _ctx.receivedBwofData.buildingSafetyManualIssuedOrUpdated,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.receivedBwofData.buildingSafetyManualIssuedOrUpdated) = $event)),
                showIcon: true,
                dateFormat: "d M yy",
                showButtonBar: true,
                class: "w-100pc",
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "disabled"]),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-plus",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addYear(_ctx.receivedBwofData.buildingSafetyManualIssuedOrUpdated))),
                disabled: _ctx.disabled
              }, null, 8, ["disabled"]), [
                [
                  _directive_tooltip,
                  'Add 1 year',
                  void 0,
                  { top: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[37] || (_cache[37] = _createElementVNode("label", null, "Building consent", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.buildingConsent,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receivedBwofData.buildingConsent) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[38] || (_cache[38] = _createElementVNode("label", null, "Compliance schedule", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.complianceSchedule,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.receivedBwofData.complianceSchedule) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[39] || (_cache[39] = _createElementVNode("label", null, "Code compliance certificate", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.codeComplianceCertificate,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receivedBwofData.codeComplianceCertificate) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives((_openBlock(), _createElementBlock("label", null, [...(_cache[40] || (_cache[40] = [
              _createTextVNode("Schedule months", -1)
            ]))])), [
              [
                _directive_tooltip,
                'Compliance schedule months',
                void 0,
                { top: true }
              ]
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedBwofData.complianceScheduleMonths,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.receivedBwofData.complianceScheduleMonths) = $event)),
              options: _ctx.complianceScheduleMonthsOptions,
              optionValue: "value",
              optionLabel: "label",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives((_openBlock(), _createElementBlock("label", null, [...(_cache[42] || (_cache[42] = [
              _createTextVNode("Schedule on file", -1)
            ]))])), [
              [
                _directive_tooltip,
                'Compliance schedule on file',
                void 0,
                { top: true }
              ]
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.receivedBwofData.complianceScheduleOnFile,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.receivedBwofData.complianceScheduleOnFile) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[44] || (_cache[44] = _createElementVNode("label", null, "Legal description", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.legalDescription,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.receivedBwofData.legalDescription) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[45] || (_cache[45] = _createElementVNode("label", null, "Location of building within site", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.locationOfBuildingWithinSite,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.receivedBwofData.locationOfBuildingWithinSite) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[46] || (_cache[46] = _createElementVNode("label", null, "Building use", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.buildingUse,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.receivedBwofData.buildingUse) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[47] || (_cache[47] = _createElementVNode("label", null, "Purpose group", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.purposeGroup,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.receivedBwofData.purposeGroup) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[48] || (_cache[48] = _createElementVNode("label", null, "Maximum number of occupants", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.maximumNumberOfOccupants,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.receivedBwofData.maximumNumberOfOccupants) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _withDirectives((_openBlock(), _createElementBlock("label", null, [...(_cache[49] || (_cache[49] = [
              _createTextVNode("Highest FHC number", -1)
            ]))])), [
              [
                _directive_tooltip,
                'Highest Fire Hazard Category',
                void 0,
                { top: true }
              ]
            ]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.highestFireHazardCategoryFhcNumber,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.receivedBwofData.highestFireHazardCategoryFhcNumber) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Level / Unit no", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedBwofData.levelUnitNo,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.receivedBwofData.levelUnitNo) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[51] || (_cache[51] = _createElementVNode("label", null, "Issued by", -1)),
            _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedBwofData.issuedBy,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.receivedBwofData.issuedBy) = $event)),
              options: _ctx.issuedByOptions,
              optionValue: "value",
              optionLabel: "label",
              showClear: true,
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[53] || (_cache[53] = _createElementVNode("label", null, "Fire report on file", -1)),
            _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.receivedBwofData.fireReportOnFile,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.receivedBwofData.fireReportOnFile) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[55] || (_cache[55] = _createElementVNode("label", null, "Compass do testing or maintenance", -1)),
            _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.receivedBwofData.compassDoTestingOrMaintenance,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.receivedBwofData.compassDoTestingOrMaintenance) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[57] || (_cache[57] = _createElementVNode("label", null, "Owner inspections completed by", -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedBwofData.ownerInspectionsCompletedBy,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.receivedBwofData.ownerInspectionsCompletedBy) = $event)),
              options: _ctx.ownerInspectionsOptions,
              optionValue: "value",
              optionLabel: "label",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[59] || (_cache[59] = _createElementVNode("label", null, "Contact", -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedBwofData.ownerContactId,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.receivedBwofData.ownerContactId) = $event)),
              options: _ctx.ownerContactsList,
              optionValue: "contactId",
              optionLabel: "firstName",
              onChange: _ctx.onOwnerContactChange,
              disabled: _ctx.disabled
            }, {
              value: _withCtx(() => [
                (_ctx.valueLabelForBwofContact.firstName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.valueLabelForBwofContact.firstName), 1))
                  : _createCommentVNode("", true),
                (_ctx.valueLabelForBwofContact.email && _ctx.valueLabelForBwofContact.firstName == null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.valueLabelForBwofContact.email), 1))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((data) => [
                _createElementVNode("span", null, _toDisplayString(data.option.firstName) + " " + _toDisplayString(data.option.lastName), 1),
                _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("small", _hoisted_32, _toDisplayString(data.option.mobile) + " " + _toDisplayString(data.option.email), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onChange", "disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}